const usStates = [
  { value: "AL", description: "Alabama" },
  { value: "AK", description: "Alaska" },
  { value: "AS", description: "American Samoa" },
  { value: "AZ", description: "Arizona" },
  { value: "AR", description: "Arkansas" },
  { value: "CA", description: "California" },
  { value: "CO", description: "Colorado" },
  { value: "CT", description: "Connecticut" },
  { value: "DE", description: "Delaware" },
  { value: "DC", description: "District Of Columbia" },
  { value: "FM", description: "Federated States Of Micronesia" },
  { value: "FL", description: "Florida" },
  { value: "GA", description: "Georgia" },
  { value: "GU", description: "Guam Gu" },
  { value: "HI", description: "Hawaii" },
  { value: "ID", description: "Idaho" },
  { value: "IL", description: "Illinois" },
  { value: "IN", description: "Indiana" },
  { value: "IA", description: "Iowa" },
  { value: "KS", description: "Kansas" },
  { value: "KY", description: "Kentucky" },
  { value: "LA", description: "Louisiana" },
  { value: "ME", description: "Maine" },
  { value: "MH", description: "Marshall Islands" },
  { value: "MD", description: "Maryland" },
  { value: "MA", description: "Massachusetts" },
  { value: "MI", description: "Michigan" },
  { value: "MN", description: "Minnesota" },
  { value: "MS", description: "Mississippi" },
  { value: "MO", description: "Missouri" },
  { value: "MT", description: "Montana" },
  { value: "NE", description: "Nebraska" },
  { value: "NV", description: "Nevada" },
  { value: "NH", description: "New Hampshire" },
  { value: "NJ", description: "New Jersey" },
  { value: "NM", description: "New Mexico" },
  { value: "NY", description: "New York" },
  { value: "NC", description: "North Carolina" },
  { value: "ND", description: "North Dakota" },
  { value: "MP", description: "Northern Mariana Islands" },
  { value: "OH", description: "Ohio" },
  { value: "OK", description: "Oklahoma" },
  { value: "OR", description: "Oregon" },
  { value: "PW", description: "Palau" },
  { value: "PA", description: "Pennsylvania" },
  { value: "PR", description: "Puerto Rico" },
  { value: "RI", description: "Rhode Island" },
  { value: "SC", description: "South Carolina" },
  { value: "SD", description: "South Dakota" },
  { value: "TN", description: "Tennessee" },
  { value: "TX", description: "Texas" },
  { value: "UT", description: "Utah" },
  { value: "VT", description: "Vermont" },
  { value: "VI", description: "Virgin Islands" },
  { value: "VA", description: "Virginia" },
  { value: "WA", description: "Washington" },
  { value: "WV", description: "West Virginia" },
  { value: "WI", description: "Wisconsin" },
  { value: "WY", description: "Wyoming" },
];

export default usStates;
